package flagpack.icons.large

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.PathData
import androidx.compose.ui.graphics.vector.group
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import flagpack.icons.FlagIcons
import org.jetbrains.compose.ui.tooling.preview.Preview

/**
 * Dominica Flag (32x24dp)
 *
 * - ISO Alpha-2: DM
 * - ISO Alpha-3: DMA
 * - ISO Numeric: 212
 *
 * @see [Flagpack](https://flagpack.xyz)
 */
public val FlagIcons.Large.Dominica: ImageVector by lazy {
    ImageVector.Builder(
        name = "Dominica:DM:DMA:212:Large",
        defaultWidth = 32.dp,
        defaultHeight = 24.dp,
        viewportWidth = 32f,
        viewportHeight = 24f
    ).apply {
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                horizontalLineToRelative(32f)
                verticalLineToRelative(24f)
                horizontalLineToRelative(-32f)
                close()
            }
        ) {
            path(fill = SolidColor(Color.White)) {
                moveTo(0f, 0f)
                horizontalLineToRelative(32f)
                verticalLineToRelative(24f)
                horizontalLineToRelative(-32f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF279E19)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 0f)
                verticalLineTo(24f)
                horizontalLineTo(32f)
                verticalLineTo(0f)
                horizontalLineTo(0f)
                close()
            }
        }
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                verticalLineTo(24f)
                horizontalLineTo(32f)
                verticalLineTo(0f)
                horizontalLineTo(0f)
                close()
            }
        ) {
            path(
                fill = SolidColor(Color(0xFFF7FCFF)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(17f, 0f)
                horizontalLineTo(19f)
                verticalLineTo(13f)
                horizontalLineTo(32f)
                verticalLineTo(15f)
                horizontalLineTo(19f)
                verticalLineTo(24f)
                horizontalLineTo(17f)
                verticalLineTo(15f)
                horizontalLineTo(0f)
                verticalLineTo(13f)
                horizontalLineTo(17f)
                verticalLineTo(0f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF272727)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(15f, 0f)
                horizontalLineTo(17f)
                verticalLineTo(11f)
                horizontalLineTo(32f)
                verticalLineTo(13f)
                horizontalLineTo(17f)
                verticalLineTo(24f)
                horizontalLineTo(15f)
                verticalLineTo(13f)
                horizontalLineTo(0f)
                verticalLineTo(11f)
                horizontalLineTo(15f)
                verticalLineTo(0f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFECA00)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(13f, 0f)
                horizontalLineTo(15f)
                verticalLineTo(9f)
                horizontalLineTo(32f)
                verticalLineTo(11f)
                horizontalLineTo(15f)
                verticalLineTo(24f)
                horizontalLineTo(13f)
                verticalLineTo(11f)
                horizontalLineTo(0f)
                verticalLineTo(9f)
                horizontalLineTo(13f)
                verticalLineTo(0f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFC51918)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(16f, 20f)
                curveTo(20.418f, 20f, 24f, 16.418f, 24f, 12f)
                curveTo(24f, 7.582f, 20.418f, 4f, 16f, 4f)
                curveTo(11.582f, 4f, 8f, 7.582f, 8f, 12f)
                curveTo(8f, 16.418f, 11.582f, 20f, 16f, 20f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF804BFF)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(14.726f, 8.413f)
                curveTo(14.726f, 8.413f, 15.106f, 7.18f, 15.988f, 7.817f)
                curveTo(17.372f, 8.499f, 17.829f, 9.282f, 18.363f, 10.169f)
                curveTo(18.898f, 11.056f, 17.053f, 10.406f, 16.709f, 9.907f)
                curveTo(16.365f, 9.408f, 14.457f, 9.246f, 14.726f, 8.829f)
                curveTo(14.995f, 8.413f, 14.726f, 8.413f, 14.726f, 8.413f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFA95601)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(14.413f, 14.726f)
                curveTo(14.413f, 14.726f, 13.473f, 16.011f, 14.413f, 16.011f)
                curveTo(15.353f, 16.011f, 19.163f, 15.734f, 18.706f, 15.368f)
                curveTo(18.249f, 15.002f, 14.865f, 15.368f, 14.865f, 15.368f)
                lineTo(14.413f, 14.726f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF804BFF)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(15.818f, 14.685f)
                curveTo(15.76f, 14.62f, 14.903f, 14.057f, 14.568f, 12.769f)
                curveTo(14.337f, 11.878f, 14.479f, 10.212f, 14.804f, 9.882f)
                curveTo(15.601f, 9.075f, 16.067f, 9.549f, 16.067f, 10.76f)
                curveTo(16.067f, 11.971f, 16.115f, 14.984f, 15.818f, 14.685f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF279E19)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(15.717f, 14.054f)
                curveTo(15.717f, 14.054f, 15.618f, 14.999f, 16.104f, 16.101f)
                curveTo(16.59f, 17.204f, 17.571f, 17.183f, 17.571f, 16.28f)
                curveTo(17.571f, 15.378f, 18.287f, 16.225f, 18.562f, 16.827f)
                curveTo(18.837f, 17.429f, 18.125f, 11.479f, 17.114f, 10.148f)
                curveTo(16.104f, 8.817f, 15.129f, 8.731f, 15.423f, 9.592f)
                curveTo(15.717f, 10.452f, 15.717f, 14.054f, 15.717f, 14.054f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFECA00)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(15.127f, 7.6f)
                curveTo(15.127f, 7.6f, 14.7f, 7.874f, 14.7f, 8.629f)
                curveTo(14.7f, 9.384f, 15.712f, 8.395f, 15.712f, 8.395f)
                lineTo(15.127f, 7.6f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF279E19)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(15.218f, 7.314f)
                lineTo(16.1f, 6.685f)
                lineTo(16.982f, 7.314f)
                lineTo(16.656f, 6.281f)
                lineTo(17.527f, 5.636f)
                lineTo(16.444f, 5.627f)
                lineTo(16.1f, 4.6f)
                lineTo(15.756f, 5.627f)
                lineTo(14.673f, 5.636f)
                lineTo(15.544f, 6.281f)
                lineTo(15.218f, 7.314f)
                close()
                moveTo(18.141f, 7.69f)
                lineTo(19.224f, 7.7f)
                lineTo(19.568f, 8.727f)
                lineTo(19.912f, 7.7f)
                lineTo(20.994f, 7.69f)
                lineTo(20.124f, 7.046f)
                lineTo(20.45f, 6.013f)
                lineTo(19.568f, 6.642f)
                lineTo(18.686f, 6.013f)
                lineTo(19.011f, 7.046f)
                lineTo(18.141f, 7.69f)
                close()
                moveTo(21.155f, 10.358f)
                lineTo(20.285f, 9.713f)
                lineTo(21.367f, 9.704f)
                lineTo(21.711f, 8.677f)
                lineTo(22.055f, 9.704f)
                lineTo(23.138f, 9.713f)
                lineTo(22.267f, 10.358f)
                lineTo(22.593f, 11.39f)
                lineTo(21.711f, 10.762f)
                lineTo(20.83f, 11.39f)
                lineTo(21.155f, 10.358f)
                close()
                moveTo(20.83f, 12.61f)
                lineTo(21.155f, 13.642f)
                lineTo(20.285f, 14.287f)
                lineTo(21.367f, 14.297f)
                lineTo(21.711f, 15.323f)
                lineTo(22.055f, 14.297f)
                lineTo(23.138f, 14.287f)
                lineTo(22.267f, 13.642f)
                lineTo(22.593f, 12.61f)
                lineTo(21.711f, 13.238f)
                lineTo(20.83f, 12.61f)
                close()
                moveTo(19.224f, 16.3f)
                lineTo(19.568f, 15.273f)
                lineTo(19.912f, 16.3f)
                lineTo(20.994f, 16.31f)
                lineTo(20.124f, 16.954f)
                lineTo(20.45f, 17.987f)
                lineTo(19.568f, 17.358f)
                lineTo(18.686f, 17.987f)
                lineTo(19.011f, 16.954f)
                lineTo(18.141f, 16.31f)
                lineTo(19.224f, 16.3f)
                close()
                moveTo(16.982f, 16.687f)
                lineTo(16.1f, 17.315f)
                lineTo(15.218f, 16.687f)
                lineTo(15.544f, 17.719f)
                lineTo(14.673f, 18.364f)
                lineTo(15.756f, 18.373f)
                lineTo(16.1f, 19.4f)
                lineTo(16.444f, 18.373f)
                lineTo(17.527f, 18.364f)
                lineTo(16.656f, 17.719f)
                lineTo(16.982f, 16.687f)
                close()
                moveTo(12.976f, 16.3f)
                lineTo(14.059f, 16.31f)
                lineTo(13.188f, 16.954f)
                lineTo(13.514f, 17.987f)
                lineTo(12.632f, 17.358f)
                lineTo(11.75f, 17.987f)
                lineTo(12.076f, 16.954f)
                lineTo(11.205f, 16.31f)
                lineTo(12.288f, 16.3f)
                lineTo(12.632f, 15.273f)
                lineTo(12.976f, 16.3f)
                close()
                moveTo(11.915f, 14.287f)
                lineTo(11.045f, 13.642f)
                lineTo(11.37f, 12.61f)
                lineTo(10.489f, 13.238f)
                lineTo(9.607f, 12.61f)
                lineTo(9.932f, 13.642f)
                lineTo(9.062f, 14.287f)
                lineTo(10.145f, 14.297f)
                lineTo(10.489f, 15.323f)
                lineTo(10.833f, 14.297f)
                lineTo(11.915f, 14.287f)
                close()
                moveTo(11.045f, 10.358f)
                lineTo(11.37f, 11.39f)
                lineTo(10.489f, 10.762f)
                lineTo(9.607f, 11.39f)
                lineTo(9.932f, 10.358f)
                lineTo(9.062f, 9.713f)
                lineTo(10.145f, 9.704f)
                lineTo(10.489f, 8.677f)
                lineTo(10.833f, 9.704f)
                lineTo(11.915f, 9.713f)
                lineTo(11.045f, 10.358f)
                close()
                moveTo(12.632f, 8.727f)
                lineTo(12.976f, 7.7f)
                lineTo(14.059f, 7.69f)
                lineTo(13.188f, 7.046f)
                lineTo(13.514f, 6.013f)
                lineTo(12.632f, 6.642f)
                lineTo(11.75f, 6.013f)
                lineTo(12.076f, 7.046f)
                lineTo(11.205f, 7.69f)
                lineTo(12.288f, 7.7f)
                lineTo(12.632f, 8.727f)
                close()
            }
        }
        group(
            clipPathData = PathData {
                moveTo(15.218f, 7.314f)
                lineTo(16.1f, 6.685f)
                lineTo(16.982f, 7.314f)
                lineTo(16.656f, 6.281f)
                lineTo(17.527f, 5.636f)
                lineTo(16.444f, 5.627f)
                lineTo(16.1f, 4.6f)
                lineTo(15.756f, 5.627f)
                lineTo(14.673f, 5.636f)
                lineTo(15.544f, 6.281f)
                lineTo(15.218f, 7.314f)
                close()
                moveTo(18.141f, 7.69f)
                lineTo(19.224f, 7.7f)
                lineTo(19.568f, 8.727f)
                lineTo(19.912f, 7.7f)
                lineTo(20.994f, 7.69f)
                lineTo(20.124f, 7.046f)
                lineTo(20.45f, 6.013f)
                lineTo(19.568f, 6.642f)
                lineTo(18.686f, 6.013f)
                lineTo(19.011f, 7.046f)
                lineTo(18.141f, 7.69f)
                close()
                moveTo(21.155f, 10.358f)
                lineTo(20.285f, 9.713f)
                lineTo(21.367f, 9.704f)
                lineTo(21.711f, 8.677f)
                lineTo(22.055f, 9.704f)
                lineTo(23.138f, 9.713f)
                lineTo(22.267f, 10.358f)
                lineTo(22.593f, 11.39f)
                lineTo(21.711f, 10.762f)
                lineTo(20.83f, 11.39f)
                lineTo(21.155f, 10.358f)
                close()
                moveTo(20.83f, 12.61f)
                lineTo(21.155f, 13.642f)
                lineTo(20.285f, 14.287f)
                lineTo(21.367f, 14.297f)
                lineTo(21.711f, 15.323f)
                lineTo(22.055f, 14.297f)
                lineTo(23.138f, 14.287f)
                lineTo(22.267f, 13.642f)
                lineTo(22.593f, 12.61f)
                lineTo(21.711f, 13.238f)
                lineTo(20.83f, 12.61f)
                close()
                moveTo(19.224f, 16.3f)
                lineTo(19.568f, 15.273f)
                lineTo(19.912f, 16.3f)
                lineTo(20.994f, 16.31f)
                lineTo(20.124f, 16.954f)
                lineTo(20.45f, 17.987f)
                lineTo(19.568f, 17.358f)
                lineTo(18.686f, 17.987f)
                lineTo(19.011f, 16.954f)
                lineTo(18.141f, 16.31f)
                lineTo(19.224f, 16.3f)
                close()
                moveTo(16.982f, 16.687f)
                lineTo(16.1f, 17.315f)
                lineTo(15.218f, 16.687f)
                lineTo(15.544f, 17.719f)
                lineTo(14.673f, 18.364f)
                lineTo(15.756f, 18.373f)
                lineTo(16.1f, 19.4f)
                lineTo(16.444f, 18.373f)
                lineTo(17.527f, 18.364f)
                lineTo(16.656f, 17.719f)
                lineTo(16.982f, 16.687f)
                close()
                moveTo(12.976f, 16.3f)
                lineTo(14.059f, 16.31f)
                lineTo(13.188f, 16.954f)
                lineTo(13.514f, 17.987f)
                lineTo(12.632f, 17.358f)
                lineTo(11.75f, 17.987f)
                lineTo(12.076f, 16.954f)
                lineTo(11.205f, 16.31f)
                lineTo(12.288f, 16.3f)
                lineTo(12.632f, 15.273f)
                lineTo(12.976f, 16.3f)
                close()
                moveTo(11.915f, 14.287f)
                lineTo(11.045f, 13.642f)
                lineTo(11.37f, 12.61f)
                lineTo(10.489f, 13.238f)
                lineTo(9.607f, 12.61f)
                lineTo(9.932f, 13.642f)
                lineTo(9.062f, 14.287f)
                lineTo(10.145f, 14.297f)
                lineTo(10.489f, 15.323f)
                lineTo(10.833f, 14.297f)
                lineTo(11.915f, 14.287f)
                close()
                moveTo(11.045f, 10.358f)
                lineTo(11.37f, 11.39f)
                lineTo(10.489f, 10.762f)
                lineTo(9.607f, 11.39f)
                lineTo(9.932f, 10.358f)
                lineTo(9.062f, 9.713f)
                lineTo(10.145f, 9.704f)
                lineTo(10.489f, 8.677f)
                lineTo(10.833f, 9.704f)
                lineTo(11.915f, 9.713f)
                lineTo(11.045f, 10.358f)
                close()
                moveTo(12.632f, 8.727f)
                lineTo(12.976f, 7.7f)
                lineTo(14.059f, 7.69f)
                lineTo(13.188f, 7.046f)
                lineTo(13.514f, 6.013f)
                lineTo(12.632f, 6.642f)
                lineTo(11.75f, 6.013f)
                lineTo(12.076f, 7.046f)
                lineTo(11.205f, 7.69f)
                lineTo(12.288f, 7.7f)
                lineTo(12.632f, 8.727f)
                close()
            }
        ) {
            path(fill = SolidColor(Color(0xFFFECA00))) {
                moveTo(16.1f, 6.685f)
                lineTo(16.158f, 6.604f)
                lineTo(16.1f, 6.562f)
                lineTo(16.042f, 6.604f)
                lineTo(16.1f, 6.685f)
                close()
                moveTo(15.218f, 7.314f)
                lineTo(15.123f, 7.283f)
                lineTo(15.033f, 7.568f)
                lineTo(15.276f, 7.395f)
                lineTo(15.218f, 7.314f)
                close()
                moveTo(16.982f, 7.314f)
                lineTo(16.924f, 7.395f)
                lineTo(17.167f, 7.568f)
                lineTo(17.077f, 7.283f)
                lineTo(16.982f, 7.314f)
                close()
                moveTo(16.656f, 6.281f)
                lineTo(16.597f, 6.2f)
                lineTo(16.539f, 6.243f)
                lineTo(16.561f, 6.311f)
                lineTo(16.656f, 6.281f)
                close()
                moveTo(17.527f, 5.636f)
                lineTo(17.586f, 5.717f)
                lineTo(17.826f, 5.539f)
                lineTo(17.527f, 5.536f)
                lineTo(17.527f, 5.636f)
                close()
                moveTo(16.444f, 5.627f)
                lineTo(16.349f, 5.658f)
                lineTo(16.372f, 5.726f)
                lineTo(16.443f, 5.727f)
                lineTo(16.444f, 5.627f)
                close()
                moveTo(16.1f, 4.6f)
                lineTo(16.195f, 4.568f)
                lineTo(16.1f, 4.285f)
                lineTo(16.005f, 4.568f)
                lineTo(16.1f, 4.6f)
                close()
                moveTo(15.756f, 5.627f)
                lineTo(15.757f, 5.727f)
                lineTo(15.828f, 5.726f)
                lineTo(15.851f, 5.658f)
                lineTo(15.756f, 5.627f)
                close()
                moveTo(14.673f, 5.636f)
                lineTo(14.672f, 5.536f)
                lineTo(14.374f, 5.539f)
                lineTo(14.614f, 5.717f)
                lineTo(14.673f, 5.636f)
                close()
                moveTo(15.544f, 6.281f)
                lineTo(15.639f, 6.311f)
                lineTo(15.66f, 6.243f)
                lineTo(15.603f, 6.2f)
                lineTo(15.544f, 6.281f)
                close()
                moveTo(19.224f, 7.7f)
                lineTo(19.319f, 7.668f)
                lineTo(19.296f, 7.601f)
                lineTo(19.225f, 7.6f)
                lineTo(19.224f, 7.7f)
                close()
                moveTo(18.141f, 7.69f)
                lineTo(18.082f, 7.61f)
                lineTo(17.842f, 7.788f)
                lineTo(18.14f, 7.79f)
                lineTo(18.141f, 7.69f)
                close()
                moveTo(19.568f, 8.727f)
                lineTo(19.473f, 8.759f)
                lineTo(19.568f, 9.042f)
                lineTo(19.663f, 8.759f)
                lineTo(19.568f, 8.727f)
                close()
                moveTo(19.912f, 7.7f)
                lineTo(19.911f, 7.6f)
                lineTo(19.84f, 7.601f)
                lineTo(19.817f, 7.668f)
                lineTo(19.912f, 7.7f)
                close()
                moveTo(20.994f, 7.69f)
                lineTo(20.995f, 7.79f)
                lineTo(21.294f, 7.788f)
                lineTo(21.054f, 7.61f)
                lineTo(20.994f, 7.69f)
                close()
                moveTo(20.124f, 7.046f)
                lineTo(20.029f, 7.016f)
                lineTo(20.007f, 7.084f)
                lineTo(20.065f, 7.126f)
                lineTo(20.124f, 7.046f)
                close()
                moveTo(20.45f, 6.013f)
                lineTo(20.545f, 6.043f)
                lineTo(20.635f, 5.759f)
                lineTo(20.392f, 5.932f)
                lineTo(20.45f, 6.013f)
                close()
                moveTo(19.568f, 6.642f)
                lineTo(19.51f, 6.723f)
                lineTo(19.568f, 6.765f)
                lineTo(19.626f, 6.723f)
                lineTo(19.568f, 6.642f)
                close()
                moveTo(18.686f, 6.013f)
                lineTo(18.744f, 5.932f)
                lineTo(18.501f, 5.759f)
                lineTo(18.591f, 6.043f)
                lineTo(18.686f, 6.013f)
                close()
                moveTo(19.011f, 7.046f)
                lineTo(19.071f, 7.126f)
                lineTo(19.128f, 7.084f)
                lineTo(19.107f, 7.016f)
                lineTo(19.011f, 7.046f)
                close()
                moveTo(20.285f, 9.713f)
                lineTo(20.284f, 9.613f)
                lineTo(19.985f, 9.616f)
                lineTo(20.225f, 9.794f)
                lineTo(20.285f, 9.713f)
                close()
                moveTo(21.155f, 10.358f)
                lineTo(21.25f, 10.388f)
                lineTo(21.272f, 10.32f)
                lineTo(21.214f, 10.277f)
                lineTo(21.155f, 10.358f)
                close()
                moveTo(21.367f, 9.704f)
                lineTo(21.368f, 9.804f)
                lineTo(21.44f, 9.803f)
                lineTo(21.462f, 9.735f)
                lineTo(21.367f, 9.704f)
                close()
                moveTo(21.711f, 8.677f)
                lineTo(21.806f, 8.645f)
                lineTo(21.711f, 8.362f)
                lineTo(21.616f, 8.645f)
                lineTo(21.711f, 8.677f)
                close()
                moveTo(22.055f, 9.704f)
                lineTo(21.96f, 9.735f)
                lineTo(21.983f, 9.803f)
                lineTo(22.054f, 9.804f)
                lineTo(22.055f, 9.704f)
                close()
                moveTo(23.138f, 9.713f)
                lineTo(23.197f, 9.794f)
                lineTo(23.437f, 9.616f)
                lineTo(23.139f, 9.613f)
                lineTo(23.138f, 9.713f)
                close()
                moveTo(22.267f, 10.358f)
                lineTo(22.208f, 10.277f)
                lineTo(22.151f, 10.32f)
                lineTo(22.172f, 10.388f)
                lineTo(22.267f, 10.358f)
                close()
                moveTo(22.593f, 11.39f)
                lineTo(22.535f, 11.472f)
                lineTo(22.778f, 11.645f)
                lineTo(22.688f, 11.36f)
                lineTo(22.593f, 11.39f)
                close()
                moveTo(21.711f, 10.762f)
                lineTo(21.769f, 10.68f)
                lineTo(21.711f, 10.639f)
                lineTo(21.653f, 10.68f)
                lineTo(21.711f, 10.762f)
                close()
                moveTo(20.83f, 11.39f)
                lineTo(20.734f, 11.36f)
                lineTo(20.644f, 11.645f)
                lineTo(20.888f, 11.472f)
                lineTo(20.83f, 11.39f)
                close()
                moveTo(21.155f, 13.642f)
                lineTo(21.214f, 13.723f)
                lineTo(21.272f, 13.68f)
                lineTo(21.25f, 13.612f)
                lineTo(21.155f, 13.642f)
                close()
                moveTo(20.83f, 12.61f)
                lineTo(20.888f, 12.528f)
                lineTo(20.644f, 12.355f)
                lineTo(20.734f, 12.64f)
                lineTo(20.83f, 12.61f)
                close()
                moveTo(20.285f, 14.287f)
                lineTo(20.225f, 14.206f)
                lineTo(19.985f, 14.384f)
                lineTo(20.284f, 14.387f)
                lineTo(20.285f, 14.287f)
                close()
                moveTo(21.367f, 14.297f)
                lineTo(21.462f, 14.265f)
                lineTo(21.44f, 14.197f)
                lineTo(21.368f, 14.196f)
                lineTo(21.367f, 14.297f)
                close()
                moveTo(21.711f, 15.323f)
                lineTo(21.616f, 15.355f)
                lineTo(21.711f, 15.638f)
                lineTo(21.806f, 15.355f)
                lineTo(21.711f, 15.323f)
                close()
                moveTo(22.055f, 14.297f)
                lineTo(22.054f, 14.196f)
                lineTo(21.983f, 14.197f)
                lineTo(21.96f, 14.265f)
                lineTo(22.055f, 14.297f)
                close()
                moveTo(23.138f, 14.287f)
                lineTo(23.139f, 14.387f)
                lineTo(23.437f, 14.384f)
                lineTo(23.197f, 14.206f)
                lineTo(23.138f, 14.287f)
                close()
                moveTo(22.267f, 13.642f)
                lineTo(22.172f, 13.612f)
                lineTo(22.151f, 13.68f)
                lineTo(22.208f, 13.723f)
                lineTo(22.267f, 13.642f)
                close()
                moveTo(22.593f, 12.61f)
                lineTo(22.688f, 12.64f)
                lineTo(22.778f, 12.355f)
                lineTo(22.535f, 12.528f)
                lineTo(22.593f, 12.61f)
                close()
                moveTo(21.711f, 13.238f)
                lineTo(21.653f, 13.32f)
                lineTo(21.711f, 13.361f)
                lineTo(21.769f, 13.32f)
                lineTo(21.711f, 13.238f)
                close()
                moveTo(19.568f, 15.273f)
                lineTo(19.663f, 15.241f)
                lineTo(19.568f, 14.958f)
                lineTo(19.473f, 15.241f)
                lineTo(19.568f, 15.273f)
                close()
                moveTo(19.224f, 16.3f)
                lineTo(19.225f, 16.4f)
                lineTo(19.296f, 16.399f)
                lineTo(19.319f, 16.332f)
                lineTo(19.224f, 16.3f)
                close()
                moveTo(19.912f, 16.3f)
                lineTo(19.817f, 16.332f)
                lineTo(19.84f, 16.399f)
                lineTo(19.911f, 16.4f)
                lineTo(19.912f, 16.3f)
                close()
                moveTo(20.994f, 16.31f)
                lineTo(21.054f, 16.39f)
                lineTo(21.294f, 16.212f)
                lineTo(20.995f, 16.21f)
                lineTo(20.994f, 16.31f)
                close()
                moveTo(20.124f, 16.954f)
                lineTo(20.065f, 16.874f)
                lineTo(20.007f, 16.916f)
                lineTo(20.029f, 16.984f)
                lineTo(20.124f, 16.954f)
                close()
                moveTo(20.45f, 17.987f)
                lineTo(20.392f, 18.068f)
                lineTo(20.635f, 18.242f)
                lineTo(20.545f, 17.957f)
                lineTo(20.45f, 17.987f)
                close()
                moveTo(19.568f, 17.358f)
                lineTo(19.626f, 17.277f)
                lineTo(19.568f, 17.235f)
                lineTo(19.51f, 17.277f)
                lineTo(19.568f, 17.358f)
                close()
                moveTo(18.686f, 17.987f)
                lineTo(18.591f, 17.957f)
                lineTo(18.501f, 18.242f)
                lineTo(18.744f, 18.068f)
                lineTo(18.686f, 17.987f)
                close()
                moveTo(19.011f, 16.954f)
                lineTo(19.107f, 16.984f)
                lineTo(19.128f, 16.916f)
                lineTo(19.071f, 16.874f)
                lineTo(19.011f, 16.954f)
                close()
                moveTo(18.141f, 16.31f)
                lineTo(18.14f, 16.21f)
                lineTo(17.842f, 16.212f)
                lineTo(18.082f, 16.39f)
                lineTo(18.141f, 16.31f)
                close()
                moveTo(16.1f, 17.315f)
                lineTo(16.042f, 17.396f)
                lineTo(16.1f, 17.438f)
                lineTo(16.158f, 17.396f)
                lineTo(16.1f, 17.315f)
                close()
                moveTo(16.982f, 16.687f)
                lineTo(17.077f, 16.716f)
                lineTo(17.167f, 16.432f)
                lineTo(16.924f, 16.605f)
                lineTo(16.982f, 16.687f)
                close()
                moveTo(15.218f, 16.687f)
                lineTo(15.276f, 16.605f)
                lineTo(15.033f, 16.432f)
                lineTo(15.123f, 16.716f)
                lineTo(15.218f, 16.687f)
                close()
                moveTo(15.544f, 17.719f)
                lineTo(15.603f, 17.8f)
                lineTo(15.66f, 17.757f)
                lineTo(15.639f, 17.689f)
                lineTo(15.544f, 17.719f)
                close()
                moveTo(14.673f, 18.364f)
                lineTo(14.614f, 18.283f)
                lineTo(14.374f, 18.461f)
                lineTo(14.672f, 18.463f)
                lineTo(14.673f, 18.364f)
                close()
                moveTo(15.756f, 18.373f)
                lineTo(15.851f, 18.341f)
                lineTo(15.828f, 18.274f)
                lineTo(15.757f, 18.273f)
                lineTo(15.756f, 18.373f)
                close()
                moveTo(16.1f, 19.4f)
                lineTo(16.005f, 19.432f)
                lineTo(16.1f, 19.715f)
                lineTo(16.195f, 19.432f)
                lineTo(16.1f, 19.4f)
                close()
                moveTo(16.444f, 18.373f)
                lineTo(16.443f, 18.273f)
                lineTo(16.372f, 18.274f)
                lineTo(16.349f, 18.341f)
                lineTo(16.444f, 18.373f)
                close()
                moveTo(17.527f, 18.364f)
                lineTo(17.527f, 18.463f)
                lineTo(17.826f, 18.461f)
                lineTo(17.586f, 18.283f)
                lineTo(17.527f, 18.364f)
                close()
                moveTo(16.656f, 17.719f)
                lineTo(16.561f, 17.689f)
                lineTo(16.539f, 17.757f)
                lineTo(16.597f, 17.8f)
                lineTo(16.656f, 17.719f)
                close()
                moveTo(14.059f, 16.31f)
                lineTo(14.118f, 16.39f)
                lineTo(14.358f, 16.212f)
                lineTo(14.059f, 16.21f)
                lineTo(14.059f, 16.31f)
                close()
                moveTo(12.976f, 16.3f)
                lineTo(12.881f, 16.332f)
                lineTo(12.904f, 16.399f)
                lineTo(12.975f, 16.4f)
                lineTo(12.976f, 16.3f)
                close()
                moveTo(13.188f, 16.954f)
                lineTo(13.129f, 16.874f)
                lineTo(13.072f, 16.916f)
                lineTo(13.093f, 16.984f)
                lineTo(13.188f, 16.954f)
                close()
                moveTo(13.514f, 17.987f)
                lineTo(13.456f, 18.068f)
                lineTo(13.699f, 18.242f)
                lineTo(13.609f, 17.957f)
                lineTo(13.514f, 17.987f)
                close()
                moveTo(12.632f, 17.358f)
                lineTo(12.69f, 17.277f)
                lineTo(12.632f, 17.235f)
                lineTo(12.574f, 17.277f)
                lineTo(12.632f, 17.358f)
                close()
                moveTo(11.75f, 17.987f)
                lineTo(11.655f, 17.957f)
                lineTo(11.565f, 18.242f)
                lineTo(11.808f, 18.068f)
                lineTo(11.75f, 17.987f)
                close()
                moveTo(12.076f, 16.954f)
                lineTo(12.171f, 16.984f)
                lineTo(12.192f, 16.916f)
                lineTo(12.135f, 16.874f)
                lineTo(12.076f, 16.954f)
                close()
                moveTo(11.205f, 16.31f)
                lineTo(11.205f, 16.21f)
                lineTo(10.906f, 16.212f)
                lineTo(11.146f, 16.39f)
                lineTo(11.205f, 16.31f)
                close()
                moveTo(12.288f, 16.3f)
                lineTo(12.289f, 16.4f)
                lineTo(12.36f, 16.399f)
                lineTo(12.383f, 16.332f)
                lineTo(12.288f, 16.3f)
                close()
                moveTo(12.632f, 15.273f)
                lineTo(12.727f, 15.241f)
                lineTo(12.632f, 14.958f)
                lineTo(12.537f, 15.241f)
                lineTo(12.632f, 15.273f)
                close()
                moveTo(11.045f, 13.642f)
                lineTo(10.95f, 13.612f)
                lineTo(10.928f, 13.68f)
                lineTo(10.986f, 13.723f)
                lineTo(11.045f, 13.642f)
                close()
                moveTo(11.915f, 14.287f)
                lineTo(11.916f, 14.387f)
                lineTo(12.215f, 14.384f)
                lineTo(11.975f, 14.206f)
                lineTo(11.915f, 14.287f)
                close()
                moveTo(11.37f, 12.61f)
                lineTo(11.466f, 12.64f)
                lineTo(11.556f, 12.355f)
                lineTo(11.312f, 12.528f)
                lineTo(11.37f, 12.61f)
                close()
                moveTo(10.489f, 13.238f)
                lineTo(10.431f, 13.32f)
                lineTo(10.489f, 13.361f)
                lineTo(10.547f, 13.32f)
                lineTo(10.489f, 13.238f)
                close()
                moveTo(9.607f, 12.61f)
                lineTo(9.665f, 12.528f)
                lineTo(9.422f, 12.355f)
                lineTo(9.512f, 12.64f)
                lineTo(9.607f, 12.61f)
                close()
                moveTo(9.932f, 13.642f)
                lineTo(9.992f, 13.723f)
                lineTo(10.049f, 13.68f)
                lineTo(10.028f, 13.612f)
                lineTo(9.932f, 13.642f)
                close()
                moveTo(9.062f, 14.287f)
                lineTo(9.003f, 14.206f)
                lineTo(8.763f, 14.384f)
                lineTo(9.061f, 14.387f)
                lineTo(9.062f, 14.287f)
                close()
                moveTo(10.145f, 14.297f)
                lineTo(10.24f, 14.265f)
                lineTo(10.217f, 14.197f)
                lineTo(10.146f, 14.196f)
                lineTo(10.145f, 14.297f)
                close()
                moveTo(10.489f, 15.323f)
                lineTo(10.394f, 15.355f)
                lineTo(10.489f, 15.638f)
                lineTo(10.583f, 15.355f)
                lineTo(10.489f, 15.323f)
                close()
                moveTo(10.833f, 14.297f)
                lineTo(10.832f, 14.196f)
                lineTo(10.76f, 14.197f)
                lineTo(10.738f, 14.265f)
                lineTo(10.833f, 14.297f)
                close()
                moveTo(11.37f, 11.39f)
                lineTo(11.312f, 11.472f)
                lineTo(11.556f, 11.645f)
                lineTo(11.466f, 11.36f)
                lineTo(11.37f, 11.39f)
                close()
                moveTo(11.045f, 10.358f)
                lineTo(10.986f, 10.277f)
                lineTo(10.928f, 10.32f)
                lineTo(10.95f, 10.388f)
                lineTo(11.045f, 10.358f)
                close()
                moveTo(10.489f, 10.762f)
                lineTo(10.547f, 10.68f)
                lineTo(10.489f, 10.639f)
                lineTo(10.431f, 10.68f)
                lineTo(10.489f, 10.762f)
                close()
                moveTo(9.607f, 11.39f)
                lineTo(9.512f, 11.36f)
                lineTo(9.422f, 11.645f)
                lineTo(9.665f, 11.472f)
                lineTo(9.607f, 11.39f)
                close()
                moveTo(9.932f, 10.358f)
                lineTo(10.028f, 10.388f)
                lineTo(10.049f, 10.32f)
                lineTo(9.992f, 10.277f)
                lineTo(9.932f, 10.358f)
                close()
                moveTo(9.062f, 9.713f)
                lineTo(9.061f, 9.613f)
                lineTo(8.763f, 9.616f)
                lineTo(9.003f, 9.794f)
                lineTo(9.062f, 9.713f)
                close()
                moveTo(10.145f, 9.704f)
                lineTo(10.146f, 9.804f)
                lineTo(10.217f, 9.803f)
                lineTo(10.24f, 9.735f)
                lineTo(10.145f, 9.704f)
                close()
                moveTo(10.489f, 8.677f)
                lineTo(10.583f, 8.645f)
                lineTo(10.489f, 8.362f)
                lineTo(10.394f, 8.645f)
                lineTo(10.489f, 8.677f)
                close()
                moveTo(10.833f, 9.704f)
                lineTo(10.738f, 9.735f)
                lineTo(10.76f, 9.803f)
                lineTo(10.832f, 9.804f)
                lineTo(10.833f, 9.704f)
                close()
                moveTo(11.915f, 9.713f)
                lineTo(11.975f, 9.794f)
                lineTo(12.215f, 9.616f)
                lineTo(11.916f, 9.613f)
                lineTo(11.915f, 9.713f)
                close()
                moveTo(12.976f, 7.7f)
                lineTo(12.975f, 7.6f)
                lineTo(12.904f, 7.601f)
                lineTo(12.881f, 7.668f)
                lineTo(12.976f, 7.7f)
                close()
                moveTo(12.632f, 8.727f)
                lineTo(12.537f, 8.759f)
                lineTo(12.632f, 9.042f)
                lineTo(12.727f, 8.759f)
                lineTo(12.632f, 8.727f)
                close()
                moveTo(14.059f, 7.69f)
                lineTo(14.059f, 7.79f)
                lineTo(14.358f, 7.788f)
                lineTo(14.118f, 7.61f)
                lineTo(14.059f, 7.69f)
                close()
                moveTo(13.188f, 7.046f)
                lineTo(13.093f, 7.016f)
                lineTo(13.072f, 7.084f)
                lineTo(13.129f, 7.126f)
                lineTo(13.188f, 7.046f)
                close()
                moveTo(13.514f, 6.013f)
                lineTo(13.609f, 6.043f)
                lineTo(13.699f, 5.759f)
                lineTo(13.456f, 5.932f)
                lineTo(13.514f, 6.013f)
                close()
                moveTo(12.632f, 6.642f)
                lineTo(12.574f, 6.723f)
                lineTo(12.632f, 6.765f)
                lineTo(12.69f, 6.723f)
                lineTo(12.632f, 6.642f)
                close()
                moveTo(11.75f, 6.013f)
                lineTo(11.808f, 5.932f)
                lineTo(11.565f, 5.759f)
                lineTo(11.655f, 6.043f)
                lineTo(11.75f, 6.013f)
                close()
                moveTo(12.076f, 7.046f)
                lineTo(12.135f, 7.126f)
                lineTo(12.192f, 7.084f)
                lineTo(12.171f, 7.016f)
                lineTo(12.076f, 7.046f)
                close()
                moveTo(11.205f, 7.69f)
                lineTo(11.146f, 7.61f)
                lineTo(10.906f, 7.788f)
                lineTo(11.205f, 7.79f)
                lineTo(11.205f, 7.69f)
                close()
                moveTo(12.288f, 7.7f)
                lineTo(12.383f, 7.668f)
                lineTo(12.36f, 7.601f)
                lineTo(12.289f, 7.6f)
                lineTo(12.288f, 7.7f)
                close()
                moveTo(16.042f, 6.604f)
                lineTo(15.16f, 7.232f)
                lineTo(15.276f, 7.395f)
                lineTo(16.158f, 6.766f)
                lineTo(16.042f, 6.604f)
                close()
                moveTo(17.04f, 7.232f)
                lineTo(16.158f, 6.604f)
                lineTo(16.042f, 6.766f)
                lineTo(16.924f, 7.395f)
                lineTo(17.04f, 7.232f)
                close()
                moveTo(16.561f, 6.311f)
                lineTo(16.886f, 7.344f)
                lineTo(17.077f, 7.283f)
                lineTo(16.752f, 6.251f)
                lineTo(16.561f, 6.311f)
                close()
                moveTo(17.467f, 5.556f)
                lineTo(16.597f, 6.2f)
                lineTo(16.716f, 6.361f)
                lineTo(17.586f, 5.717f)
                lineTo(17.467f, 5.556f)
                close()
                moveTo(16.443f, 5.727f)
                lineTo(17.526f, 5.736f)
                lineTo(17.527f, 5.536f)
                lineTo(16.445f, 5.527f)
                lineTo(16.443f, 5.727f)
                close()
                moveTo(16.005f, 4.632f)
                lineTo(16.349f, 5.658f)
                lineTo(16.539f, 5.595f)
                lineTo(16.195f, 4.568f)
                lineTo(16.005f, 4.632f)
                close()
                moveTo(15.851f, 5.658f)
                lineTo(16.195f, 4.632f)
                lineTo(16.005f, 4.568f)
                lineTo(15.661f, 5.595f)
                lineTo(15.851f, 5.658f)
                close()
                moveTo(14.674f, 5.736f)
                lineTo(15.757f, 5.727f)
                lineTo(15.755f, 5.527f)
                lineTo(14.672f, 5.536f)
                lineTo(14.674f, 5.736f)
                close()
                moveTo(15.603f, 6.2f)
                lineTo(14.733f, 5.556f)
                lineTo(14.614f, 5.717f)
                lineTo(15.484f, 6.361f)
                lineTo(15.603f, 6.2f)
                close()
                moveTo(15.314f, 7.344f)
                lineTo(15.639f, 6.311f)
                lineTo(15.448f, 6.251f)
                lineTo(15.123f, 7.283f)
                lineTo(15.314f, 7.344f)
                close()
                moveTo(19.225f, 7.6f)
                lineTo(18.142f, 7.59f)
                lineTo(18.14f, 7.79f)
                lineTo(19.223f, 7.8f)
                lineTo(19.225f, 7.6f)
                close()
                moveTo(19.663f, 8.695f)
                lineTo(19.319f, 7.668f)
                lineTo(19.129f, 7.732f)
                lineTo(19.473f, 8.759f)
                lineTo(19.663f, 8.695f)
                close()
                moveTo(19.817f, 7.668f)
                lineTo(19.473f, 8.695f)
                lineTo(19.663f, 8.759f)
                lineTo(20.007f, 7.732f)
                lineTo(19.817f, 7.668f)
                close()
                moveTo(20.994f, 7.59f)
                lineTo(19.911f, 7.6f)
                lineTo(19.913f, 7.8f)
                lineTo(20.995f, 7.79f)
                lineTo(20.994f, 7.59f)
                close()
                moveTo(20.065f, 7.126f)
                lineTo(20.935f, 7.771f)
                lineTo(21.054f, 7.61f)
                lineTo(20.184f, 6.966f)
                lineTo(20.065f, 7.126f)
                close()
                moveTo(20.354f, 5.983f)
                lineTo(20.029f, 7.016f)
                lineTo(20.22f, 7.076f)
                lineTo(20.545f, 6.043f)
                lineTo(20.354f, 5.983f)
                close()
                moveTo(19.626f, 6.723f)
                lineTo(20.508f, 6.095f)
                lineTo(20.392f, 5.932f)
                lineTo(19.51f, 6.56f)
                lineTo(19.626f, 6.723f)
                close()
                moveTo(18.628f, 6.095f)
                lineTo(19.51f, 6.723f)
                lineTo(19.626f, 6.56f)
                lineTo(18.744f, 5.932f)
                lineTo(18.628f, 6.095f)
                close()
                moveTo(19.107f, 7.016f)
                lineTo(18.782f, 5.983f)
                lineTo(18.591f, 6.043f)
                lineTo(18.916f, 7.076f)
                lineTo(19.107f, 7.016f)
                close()
                moveTo(18.201f, 7.771f)
                lineTo(19.071f, 7.126f)
                lineTo(18.952f, 6.966f)
                lineTo(18.082f, 7.61f)
                lineTo(18.201f, 7.771f)
                close()
                moveTo(20.225f, 9.794f)
                lineTo(21.095f, 10.438f)
                lineTo(21.214f, 10.277f)
                lineTo(20.344f, 9.633f)
                lineTo(20.225f, 9.794f)
                close()
                moveTo(21.366f, 9.604f)
                lineTo(20.284f, 9.613f)
                lineTo(20.285f, 9.813f)
                lineTo(21.368f, 9.804f)
                lineTo(21.366f, 9.604f)
                close()
                moveTo(21.616f, 8.645f)
                lineTo(21.272f, 9.672f)
                lineTo(21.462f, 9.735f)
                lineTo(21.806f, 8.709f)
                lineTo(21.616f, 8.645f)
                close()
                moveTo(22.15f, 9.672f)
                lineTo(21.806f, 8.645f)
                lineTo(21.616f, 8.709f)
                lineTo(21.96f, 9.735f)
                lineTo(22.15f, 9.672f)
                close()
                moveTo(23.139f, 9.613f)
                lineTo(22.056f, 9.604f)
                lineTo(22.054f, 9.804f)
                lineTo(23.137f, 9.813f)
                lineTo(23.139f, 9.613f)
                close()
                moveTo(22.327f, 10.438f)
                lineTo(23.197f, 9.794f)
                lineTo(23.078f, 9.633f)
                lineTo(22.208f, 10.277f)
                lineTo(22.327f, 10.438f)
                close()
                moveTo(22.688f, 11.36f)
                lineTo(22.363f, 10.328f)
                lineTo(22.172f, 10.388f)
                lineTo(22.497f, 11.42f)
                lineTo(22.688f, 11.36f)
                close()
                moveTo(21.653f, 10.843f)
                lineTo(22.535f, 11.472f)
                lineTo(22.651f, 11.309f)
                lineTo(21.769f, 10.68f)
                lineTo(21.653f, 10.843f)
                close()
                moveTo(20.888f, 11.472f)
                lineTo(21.769f, 10.843f)
                lineTo(21.653f, 10.68f)
                lineTo(20.771f, 11.309f)
                lineTo(20.888f, 11.472f)
                close()
                moveTo(21.059f, 10.328f)
                lineTo(20.734f, 11.36f)
                lineTo(20.925f, 11.42f)
                lineTo(21.25f, 10.388f)
                lineTo(21.059f, 10.328f)
                close()
                moveTo(21.25f, 13.612f)
                lineTo(20.925f, 12.58f)
                lineTo(20.734f, 12.64f)
                lineTo(21.059f, 13.672f)
                lineTo(21.25f, 13.612f)
                close()
                moveTo(20.344f, 14.367f)
                lineTo(21.214f, 13.723f)
                lineTo(21.095f, 13.562f)
                lineTo(20.225f, 14.206f)
                lineTo(20.344f, 14.367f)
                close()
                moveTo(21.368f, 14.196f)
                lineTo(20.285f, 14.187f)
                lineTo(20.284f, 14.387f)
                lineTo(21.366f, 14.396f)
                lineTo(21.368f, 14.196f)
                close()
                moveTo(21.806f, 15.291f)
                lineTo(21.462f, 14.265f)
                lineTo(21.272f, 14.328f)
                lineTo(21.616f, 15.355f)
                lineTo(21.806f, 15.291f)
                close()
                moveTo(21.96f, 14.265f)
                lineTo(21.616f, 15.291f)
                lineTo(21.806f, 15.355f)
                lineTo(22.15f, 14.328f)
                lineTo(21.96f, 14.265f)
                close()
                moveTo(23.137f, 14.187f)
                lineTo(22.054f, 14.196f)
                lineTo(22.056f, 14.396f)
                lineTo(23.139f, 14.387f)
                lineTo(23.137f, 14.187f)
                close()
                moveTo(22.208f, 13.723f)
                lineTo(23.078f, 14.367f)
                lineTo(23.197f, 14.206f)
                lineTo(22.327f, 13.562f)
                lineTo(22.208f, 13.723f)
                close()
                moveTo(22.497f, 12.58f)
                lineTo(22.172f, 13.612f)
                lineTo(22.363f, 13.672f)
                lineTo(22.688f, 12.64f)
                lineTo(22.497f, 12.58f)
                close()
                moveTo(21.769f, 13.32f)
                lineTo(22.651f, 12.691f)
                lineTo(22.535f, 12.528f)
                lineTo(21.653f, 13.157f)
                lineTo(21.769f, 13.32f)
                close()
                moveTo(20.771f, 12.691f)
                lineTo(21.653f, 13.32f)
                lineTo(21.769f, 13.157f)
                lineTo(20.888f, 12.528f)
                lineTo(20.771f, 12.691f)
                close()
                moveTo(19.473f, 15.241f)
                lineTo(19.129f, 16.268f)
                lineTo(19.319f, 16.332f)
                lineTo(19.663f, 15.305f)
                lineTo(19.473f, 15.241f)
                close()
                moveTo(20.007f, 16.268f)
                lineTo(19.663f, 15.241f)
                lineTo(19.473f, 15.305f)
                lineTo(19.817f, 16.332f)
                lineTo(20.007f, 16.268f)
                close()
                moveTo(20.995f, 16.21f)
                lineTo(19.913f, 16.2f)
                lineTo(19.911f, 16.4f)
                lineTo(20.994f, 16.41f)
                lineTo(20.995f, 16.21f)
                close()
                moveTo(20.184f, 17.034f)
                lineTo(21.054f, 16.39f)
                lineTo(20.935f, 16.229f)
                lineTo(20.065f, 16.874f)
                lineTo(20.184f, 17.034f)
                close()
                moveTo(20.545f, 17.957f)
                lineTo(20.22f, 16.924f)
                lineTo(20.029f, 16.984f)
                lineTo(20.354f, 18.017f)
                lineTo(20.545f, 17.957f)
                close()
                moveTo(19.51f, 17.44f)
                lineTo(20.392f, 18.068f)
                lineTo(20.508f, 17.905f)
                lineTo(19.626f, 17.277f)
                lineTo(19.51f, 17.44f)
                close()
                moveTo(18.744f, 18.068f)
                lineTo(19.626f, 17.44f)
                lineTo(19.51f, 17.277f)
                lineTo(18.628f, 17.905f)
                lineTo(18.744f, 18.068f)
                close()
                moveTo(18.916f, 16.924f)
                lineTo(18.591f, 17.957f)
                lineTo(18.782f, 18.017f)
                lineTo(19.107f, 16.984f)
                lineTo(18.916f, 16.924f)
                close()
                moveTo(18.082f, 16.39f)
                lineTo(18.952f, 17.034f)
                lineTo(19.071f, 16.874f)
                lineTo(18.201f, 16.229f)
                lineTo(18.082f, 16.39f)
                close()
                moveTo(19.223f, 16.2f)
                lineTo(18.14f, 16.21f)
                lineTo(18.142f, 16.41f)
                lineTo(19.225f, 16.4f)
                lineTo(19.223f, 16.2f)
                close()
                moveTo(16.158f, 17.396f)
                lineTo(17.04f, 16.768f)
                lineTo(16.924f, 16.605f)
                lineTo(16.042f, 17.234f)
                lineTo(16.158f, 17.396f)
                close()
                moveTo(15.16f, 16.768f)
                lineTo(16.042f, 17.396f)
                lineTo(16.158f, 17.234f)
                lineTo(15.276f, 16.605f)
                lineTo(15.16f, 16.768f)
                close()
                moveTo(15.639f, 17.689f)
                lineTo(15.314f, 16.656f)
                lineTo(15.123f, 16.716f)
                lineTo(15.448f, 17.749f)
                lineTo(15.639f, 17.689f)
                close()
                moveTo(14.733f, 18.444f)
                lineTo(15.603f, 17.8f)
                lineTo(15.484f, 17.639f)
                lineTo(14.614f, 18.283f)
                lineTo(14.733f, 18.444f)
                close()
                moveTo(15.757f, 18.273f)
                lineTo(14.674f, 18.264f)
                lineTo(14.672f, 18.463f)
                lineTo(15.755f, 18.473f)
                lineTo(15.757f, 18.273f)
                close()
                moveTo(16.195f, 19.368f)
                lineTo(15.851f, 18.341f)
                lineTo(15.661f, 18.405f)
                lineTo(16.005f, 19.432f)
                lineTo(16.195f, 19.368f)
                close()
                moveTo(16.349f, 18.341f)
                lineTo(16.005f, 19.368f)
                lineTo(16.195f, 19.432f)
                lineTo(16.539f, 18.405f)
                lineTo(16.349f, 18.341f)
                close()
                moveTo(17.526f, 18.264f)
                lineTo(16.443f, 18.273f)
                lineTo(16.445f, 18.473f)
                lineTo(17.527f, 18.463f)
                lineTo(17.526f, 18.264f)
                close()
                moveTo(16.597f, 17.8f)
                lineTo(17.467f, 18.444f)
                lineTo(17.586f, 18.283f)
                lineTo(16.716f, 17.639f)
                lineTo(16.597f, 17.8f)
                close()
                moveTo(16.886f, 16.656f)
                lineTo(16.561f, 17.689f)
                lineTo(16.752f, 17.749f)
                lineTo(17.077f, 16.716f)
                lineTo(16.886f, 16.656f)
                close()
                moveTo(14.059f, 16.21f)
                lineTo(12.977f, 16.2f)
                lineTo(12.975f, 16.4f)
                lineTo(14.058f, 16.41f)
                lineTo(14.059f, 16.21f)
                close()
                moveTo(13.248f, 17.034f)
                lineTo(14.118f, 16.39f)
                lineTo(13.999f, 16.229f)
                lineTo(13.129f, 16.874f)
                lineTo(13.248f, 17.034f)
                close()
                moveTo(13.609f, 17.957f)
                lineTo(13.284f, 16.924f)
                lineTo(13.093f, 16.984f)
                lineTo(13.418f, 18.017f)
                lineTo(13.609f, 17.957f)
                close()
                moveTo(12.574f, 17.44f)
                lineTo(13.456f, 18.068f)
                lineTo(13.572f, 17.905f)
                lineTo(12.69f, 17.277f)
                lineTo(12.574f, 17.44f)
                close()
                moveTo(11.808f, 18.068f)
                lineTo(12.69f, 17.44f)
                lineTo(12.574f, 17.277f)
                lineTo(11.692f, 17.905f)
                lineTo(11.808f, 18.068f)
                close()
                moveTo(11.98f, 16.924f)
                lineTo(11.655f, 17.957f)
                lineTo(11.846f, 18.017f)
                lineTo(12.171f, 16.984f)
                lineTo(11.98f, 16.924f)
                close()
                moveTo(11.146f, 16.39f)
                lineTo(12.016f, 17.034f)
                lineTo(12.135f, 16.874f)
                lineTo(11.265f, 16.229f)
                lineTo(11.146f, 16.39f)
                close()
                moveTo(12.287f, 16.2f)
                lineTo(11.205f, 16.21f)
                lineTo(11.206f, 16.41f)
                lineTo(12.289f, 16.4f)
                lineTo(12.287f, 16.2f)
                close()
                moveTo(12.537f, 15.241f)
                lineTo(12.193f, 16.268f)
                lineTo(12.383f, 16.332f)
                lineTo(12.727f, 15.305f)
                lineTo(12.537f, 15.241f)
                close()
                moveTo(13.071f, 16.268f)
                lineTo(12.727f, 15.241f)
                lineTo(12.537f, 15.305f)
                lineTo(12.881f, 16.332f)
                lineTo(13.071f, 16.268f)
                close()
                moveTo(10.986f, 13.723f)
                lineTo(11.856f, 14.367f)
                lineTo(11.975f, 14.206f)
                lineTo(11.105f, 13.562f)
                lineTo(10.986f, 13.723f)
                close()
                moveTo(11.275f, 12.58f)
                lineTo(10.95f, 13.612f)
                lineTo(11.141f, 13.672f)
                lineTo(11.466f, 12.64f)
                lineTo(11.275f, 12.58f)
                close()
                moveTo(10.547f, 13.32f)
                lineTo(11.428f, 12.691f)
                lineTo(11.312f, 12.528f)
                lineTo(10.431f, 13.157f)
                lineTo(10.547f, 13.32f)
                close()
                moveTo(9.549f, 12.691f)
                lineTo(10.431f, 13.32f)
                lineTo(10.547f, 13.157f)
                lineTo(9.665f, 12.528f)
                lineTo(9.549f, 12.691f)
                close()
                moveTo(10.028f, 13.612f)
                lineTo(9.702f, 12.58f)
                lineTo(9.512f, 12.64f)
                lineTo(9.837f, 13.672f)
                lineTo(10.028f, 13.612f)
                close()
                moveTo(9.122f, 14.367f)
                lineTo(9.992f, 13.723f)
                lineTo(9.873f, 13.562f)
                lineTo(9.003f, 14.206f)
                lineTo(9.122f, 14.367f)
                close()
                moveTo(10.146f, 14.196f)
                lineTo(9.063f, 14.187f)
                lineTo(9.061f, 14.387f)
                lineTo(10.144f, 14.396f)
                lineTo(10.146f, 14.196f)
                close()
                moveTo(10.583f, 15.291f)
                lineTo(10.24f, 14.265f)
                lineTo(10.05f, 14.328f)
                lineTo(10.394f, 15.355f)
                lineTo(10.583f, 15.291f)
                close()
                moveTo(10.738f, 14.265f)
                lineTo(10.394f, 15.291f)
                lineTo(10.583f, 15.355f)
                lineTo(10.927f, 14.328f)
                lineTo(10.738f, 14.265f)
                close()
                moveTo(11.914f, 14.187f)
                lineTo(10.832f, 14.196f)
                lineTo(10.833f, 14.396f)
                lineTo(11.916f, 14.387f)
                lineTo(11.914f, 14.187f)
                close()
                moveTo(11.466f, 11.36f)
                lineTo(11.141f, 10.328f)
                lineTo(10.95f, 10.388f)
                lineTo(11.275f, 11.42f)
                lineTo(11.466f, 11.36f)
                close()
                moveTo(10.431f, 10.843f)
                lineTo(11.312f, 11.472f)
                lineTo(11.428f, 11.309f)
                lineTo(10.547f, 10.68f)
                lineTo(10.431f, 10.843f)
                close()
                moveTo(9.665f, 11.472f)
                lineTo(10.547f, 10.843f)
                lineTo(10.431f, 10.68f)
                lineTo(9.549f, 11.309f)
                lineTo(9.665f, 11.472f)
                close()
                moveTo(9.837f, 10.328f)
                lineTo(9.512f, 11.36f)
                lineTo(9.702f, 11.42f)
                lineTo(10.028f, 10.388f)
                lineTo(9.837f, 10.328f)
                close()
                moveTo(9.003f, 9.794f)
                lineTo(9.873f, 10.438f)
                lineTo(9.992f, 10.277f)
                lineTo(9.122f, 9.633f)
                lineTo(9.003f, 9.794f)
                close()
                moveTo(10.144f, 9.604f)
                lineTo(9.061f, 9.613f)
                lineTo(9.063f, 9.813f)
                lineTo(10.146f, 9.804f)
                lineTo(10.144f, 9.604f)
                close()
                moveTo(10.394f, 8.645f)
                lineTo(10.05f, 9.672f)
                lineTo(10.24f, 9.735f)
                lineTo(10.583f, 8.709f)
                lineTo(10.394f, 8.645f)
                close()
                moveTo(10.927f, 9.672f)
                lineTo(10.583f, 8.645f)
                lineTo(10.394f, 8.709f)
                lineTo(10.738f, 9.735f)
                lineTo(10.927f, 9.672f)
                close()
                moveTo(11.916f, 9.613f)
                lineTo(10.833f, 9.604f)
                lineTo(10.832f, 9.804f)
                lineTo(11.914f, 9.813f)
                lineTo(11.916f, 9.613f)
                close()
                moveTo(11.105f, 10.438f)
                lineTo(11.975f, 9.794f)
                lineTo(11.856f, 9.633f)
                lineTo(10.986f, 10.277f)
                lineTo(11.105f, 10.438f)
                close()
                moveTo(12.881f, 7.668f)
                lineTo(12.537f, 8.695f)
                lineTo(12.727f, 8.759f)
                lineTo(13.071f, 7.732f)
                lineTo(12.881f, 7.668f)
                close()
                moveTo(14.058f, 7.59f)
                lineTo(12.975f, 7.6f)
                lineTo(12.977f, 7.8f)
                lineTo(14.059f, 7.79f)
                lineTo(14.058f, 7.59f)
                close()
                moveTo(13.129f, 7.126f)
                lineTo(13.999f, 7.771f)
                lineTo(14.118f, 7.61f)
                lineTo(13.248f, 6.966f)
                lineTo(13.129f, 7.126f)
                close()
                moveTo(13.418f, 5.983f)
                lineTo(13.093f, 7.016f)
                lineTo(13.284f, 7.076f)
                lineTo(13.609f, 6.043f)
                lineTo(13.418f, 5.983f)
                close()
                moveTo(12.69f, 6.723f)
                lineTo(13.572f, 6.095f)
                lineTo(13.456f, 5.932f)
                lineTo(12.574f, 6.56f)
                lineTo(12.69f, 6.723f)
                close()
                moveTo(11.692f, 6.095f)
                lineTo(12.574f, 6.723f)
                lineTo(12.69f, 6.56f)
                lineTo(11.808f, 5.932f)
                lineTo(11.692f, 6.095f)
                close()
                moveTo(12.171f, 7.016f)
                lineTo(11.846f, 5.983f)
                lineTo(11.655f, 6.043f)
                lineTo(11.98f, 7.076f)
                lineTo(12.171f, 7.016f)
                close()
                moveTo(11.265f, 7.771f)
                lineTo(12.135f, 7.126f)
                lineTo(12.016f, 6.966f)
                lineTo(11.146f, 7.61f)
                lineTo(11.265f, 7.771f)
                close()
                moveTo(12.289f, 7.6f)
                lineTo(11.206f, 7.59f)
                lineTo(11.205f, 7.79f)
                lineTo(12.287f, 7.8f)
                lineTo(12.289f, 7.6f)
                close()
                moveTo(12.727f, 8.695f)
                lineTo(12.383f, 7.668f)
                lineTo(12.193f, 7.732f)
                lineTo(12.537f, 8.759f)
                lineTo(12.727f, 8.695f)
                close()
            }
        }
    }.build()
}

@Preview
@Composable
private fun DominicaPreview() {
    Box(modifier = Modifier.padding(12.dp)) {
        Image(
            imageVector = FlagIcons.Large.Dominica,
            contentDescription = "Dominica Flag"
        )
    }
}
